var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout"},[_c('top-header'),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"mb-3"},[_c('top-nevleft'),_c('b-col',{staticClass:"p-0"},[_c('order_details'),_c('top-footer')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }